module.exports = __webpack_public_path__ + "b272b6ea6f3c0ade1b135feeaf549104.png";